export default "__VITE_ASSET__CMPdNuEs__"